import { request } from './_core'

// ── Subscriptions ─────────────────────────────────────────────

export interface SubscriptionInfo {
  tier:      'BASIC' | 'PLUS' | 'PREMIUM'
  status:    string
  isActive:  boolean
  startsAt:  string
  expiresAt: string | null
}

export interface StripePriceInfo {
  amount:   number | null   // in cents, e.g. 499 = €4.99
  currency: string          // e.g. "eur"
  interval: string          // e.g. "month"
}

export interface SubscriptionPrices {
  plus:    StripePriceInfo | null
  premium: StripePriceInfo | null
}

export const subscriptions = {
  me: () => request<SubscriptionInfo>('/subscriptions/me'),

  prices: () => request<SubscriptionPrices>('/subscriptions/prices'),

  // Returns a Stripe Checkout URL; caller should redirect to it
  checkout: (tier: 'PLUS' | 'PREMIUM') =>
    request<{ url: string }>('/subscriptions/checkout', {
      method: 'POST',
      body:   JSON.stringify({ tier }),
    }),

  // Returns a Stripe Customer Portal URL; caller should redirect to it
  portal: () =>
    request<{ url: string }>('/subscriptions/portal', { method: 'POST' }),

  upgrade: (data: { userId: string; tier: 'BASIC' | 'PLUS' | 'PREMIUM'; expiresAt?: string }) =>
    request<SubscriptionInfo>('/subscriptions/upgrade', {
      method: 'PATCH',
      body:   JSON.stringify(data),
    }),
}
